import styled from '@emotion/styled'

const StyledTitle = styled.div`
  font-weight: 800;
`
const StyledHeader = styled.div`
  border-bottom: 1px solid #dbdfea;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const StyledContent = styled.div`
  padding: 1.5rem 1.5rem;
  flex: 1;
`
const StyledFooter = styled.div`
  width: 100%;
  bottom: 0;
  padding: 0.5rem 1rem;
  background-color: #e5e9f2;
  border-top: 1px solid #dbdfea;
  .footer-box {
    display: flex;
    justify-content: flex-end;
  }
`
const StyleIcon = styled.div`
  cursor: pointer;
`

export { StyledContent, StyledTitle, StyledHeader, StyledFooter, StyleIcon }
